export const LIMIT_DESKTOP = 12;
export const LIMIT_PHONE = 4;
